/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_App_Rescue_Work_0_Metric_1_LabelInputs */

const en_svc_ai_app_rescue_work_0_metric_1_label = /** @type {(inputs: Svc_Ai_App_Rescue_Work_0_Metric_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Real-time events`)
};

const ar_svc_ai_app_rescue_work_0_metric_1_label = /** @type {(inputs: Svc_Ai_App_Rescue_Work_0_Metric_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أحداث لحظية`)
};

const bn_svc_ai_app_rescue_work_0_metric_1_label = /** @type {(inputs: Svc_Ai_App_Rescue_Work_0_Metric_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`রিয়েল-টাইম ইভেন্ট`)
};

const de_svc_ai_app_rescue_work_0_metric_1_label = /** @type {(inputs: Svc_Ai_App_Rescue_Work_0_Metric_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Echtzeitereignisse`)
};

const es_svc_ai_app_rescue_work_0_metric_1_label = /** @type {(inputs: Svc_Ai_App_Rescue_Work_0_Metric_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eventos en tiempo real`)
};

const fr_svc_ai_app_rescue_work_0_metric_1_label = /** @type {(inputs: Svc_Ai_App_Rescue_Work_0_Metric_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Événements en temps réel`)
};

const pt_svc_ai_app_rescue_work_0_metric_1_label = /** @type {(inputs: Svc_Ai_App_Rescue_Work_0_Metric_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eventos em tempo real`)
};

const zh_svc_ai_app_rescue_work_0_metric_1_label = /** @type {(inputs: Svc_Ai_App_Rescue_Work_0_Metric_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`实时事件`)
};

const tr_svc_ai_app_rescue_work_0_metric_1_label = /** @type {(inputs: Svc_Ai_App_Rescue_Work_0_Metric_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerçek zamanlı etkinlikler`)
};

const ru_svc_ai_app_rescue_work_0_metric_1_label = /** @type {(inputs: Svc_Ai_App_Rescue_Work_0_Metric_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`События в реальном времени`)
};

const pl_svc_ai_app_rescue_work_0_metric_1_label = /** @type {(inputs: Svc_Ai_App_Rescue_Work_0_Metric_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wydarzenia w czasie rzeczywistym`)
};

/**
* | output |
* | --- |
* | "Real-time events" |
*
* @param {Svc_Ai_App_Rescue_Work_0_Metric_1_LabelInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_app_rescue_work_0_metric_1_label = /** @type {((inputs?: Svc_Ai_App_Rescue_Work_0_Metric_1_LabelInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_App_Rescue_Work_0_Metric_1_LabelInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_app_rescue_work_0_metric_1_label(inputs)
	if (locale === "bn") return bn_svc_ai_app_rescue_work_0_metric_1_label(inputs)
	if (locale === "de") return de_svc_ai_app_rescue_work_0_metric_1_label(inputs)
	if (locale === "es") return es_svc_ai_app_rescue_work_0_metric_1_label(inputs)
	if (locale === "fr") return fr_svc_ai_app_rescue_work_0_metric_1_label(inputs)
	if (locale === "pt") return pt_svc_ai_app_rescue_work_0_metric_1_label(inputs)
	if (locale === "zh") return zh_svc_ai_app_rescue_work_0_metric_1_label(inputs)
	if (locale === "tr") return tr_svc_ai_app_rescue_work_0_metric_1_label(inputs)
	if (locale === "ru") return ru_svc_ai_app_rescue_work_0_metric_1_label(inputs)
	if (locale === "pl") return pl_svc_ai_app_rescue_work_0_metric_1_label(inputs)
	return en_svc_ai_app_rescue_work_0_metric_1_label(inputs)
});
export { svc_ai_app_rescue_work_0_metric_1_label as "svc_ai-app-rescue_work_0_metric_1_label" }